module.exports = __webpack_public_path__ + "img/13.aa121d27.jpg";